import { graphql } from 'src/gql'
import { StaffingAgencyPocsQueryVariables, SortFindManyStaffingAgencyPocInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyPocs($sort: SortFindManyStaffingAgencyPocInput, $filter: FilterFindManyStaffingAgencyPocInput) {
    cat {
      staffingAgencyPoc {
        many(sort: $sort, filter: $filter) {
          _id
          name
          title
          email
          phone
          _timezone {
            _id
            name
            abbreviation
          }
          _type {
            _id
            name
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyPocs = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['staffingAgencyPoc']>['many']>

const useStaffingAgencyPocs = (variables?: StaffingAgencyPocsQueryVariables, options?: UseGraphqlOptions<TData>, enabled: boolean = true): StaffingAgencyPocs => {
  const internalVariables: StaffingAgencyPocsQueryVariables = Object.assign({
    sort: SortFindManyStaffingAgencyPocInput.NameAsc,
    limit: 1000
  }, variables)
  const { data } = useGraphQL(document, internalVariables, options)
  return data?.cat?.staffingAgencyPoc?.many ?? []
}

export { useStaffingAgencyPocs, document as staffingAgencyPocsDocument }
